import {GetSeferData} from "SeferPetach/GetData";

export async function getApplicationDocumentation() {
    var payload = await GetSeferData("appdoc", {});
    return (payload);
}
